<template>
    <div class="d-flex flex-row justify-content-start align-items-start flex-wrap flex-gap">

            <b-button v-on:click="downloadCSV" size="sm"> <v-icon name="download"/>CSV</b-button>

            <form v-if="!$store.getters['event/isEquipeResults']"
                :action="$store.getters.base_url + '/files/listing_pdf.php'" method="POST" target="_blank">
                <input type="hidden" name="id_epreuve" :value="epreuve.id" />
                <input type="hidden" name="parcours" :value="epreuve.course" />
                <!-- <input type="hidden" name="data" v-if="epreuve.id_module == 994"
                    :value="JSON.stringify(this.itemsForEmorcSolo())" /> -->
                <input type="hidden" name="data"  :value="$store.getters['event/listResultatsFilteredForPDF']" />
                <b-button type="submit" size="sm"> <v-icon name="download" /> PDF</b-button>
            </form>

            <form v-if="$store.getters['event/isEquipeResults']"
                :action="$store.getters.base_url + '/files/listing_equipes_pdf.php'" method="POST" target="_blank">
                <input type="hidden" name="id_epreuve" :value="epreuve.id" />
                <input type="hidden" name="parcours" :value="epreuve.course" />
                <input type="hidden" name="data" :value="$store.getters['event/listResultatsEquipesForPDF']" />
                <b-button type="submit" size="sm"> <v-icon name="download" /> PDF</b-button>
            </form>


    </div>
</template>

<script>
import Papa from "papaparse";
export default {
    name: 'DownloadSelectionSection',
    computed: {
        epreuve() {
            return this.$store.state.event.data;
        },

    },
    methods: {
        downloadCSV() {
            const resultsForCSV = this.$store.getters['event/listResultatsFilteredAsCSV'];
           var csv = Papa.unparse(resultsForCSV, { delimiter: ";" });
            var csvData = new Blob(["\ufeff", csv], {
                type: "text/csv;charset=utf-8;",
            });
            var csvURL = null;
            if (navigator.msSaveBlob) {
                csvURL = navigator.msSaveBlob(csvData, "download.csv");
            } else {
                csvURL = window.URL.createObjectURL(csvData);
            }
            var tempLink = document.createElement("a");
            tempLink.href = csvURL;
            tempLink.setAttribute("download", "Résultats-Sportips " + this.epreuve.course + ".csv");
            tempLink.click();
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/component/Epreuve/DownloadSelectionSection.vue